<template>
  <a-card :bordered='false'>
    <div class='m-b-20 s_flex_ali'>
      <span class='mr15'>
        <a-button type="primary" v-has:antiSystemHouseAddOne="()=>visibleToggle('add',1)">添加仓库</a-button>
      </span>
      <span class='mr15' v-if="cateList.length">
        <a-button type="link" @click="changActiveKey">
          {{activeKey.length?'收起所有仓库':'展开所有仓库'}}
        </a-button>
      </span>
    </div>
    <a-spin :spinning='loading'>
      <a-collapse v-if="cateList.length" @change="changActive" v-model:activeKey="activeKey">
        <a-collapse-panel :header="v.name" v-for="(v,key) in cateList" :key='String(key)'>
          <template #extra>
            <a-button type="link" v-has:antiSystemHouseAddTwo="()=>visibleToggle('add',2,v)">
              新增库位
            </a-button>
            <a-button type="link" v-has:antiSystemHouseEditOne="()=>visibleToggle('edit',1,v)">编辑</a-button>
            <a-button type="link" v-has:antiSystemHouseDelOne="()=>del(v)">删除</a-button>
          </template>
          <div v-for="(value,key) in v.child" :key="key" class='p-t-15 p-b-15 p-l-70 secondCate s_flex_bian_c m-b-10' style="background:#f5f5f5;">
            <span>{{ value.name }}</span>
            <div>
              <a-button type="link" v-has:antiSystemHouseEditTwo="()=>visibleToggle('edit',2,value)">编辑</a-button>
              <a-button type="link" v-has:antiSystemHouseDelTwo="()=>del(value)">删除</a-button>
            </div>
          </div>
          <a-empty v-if="!v.child"/>
        </a-collapse-panel>
      </a-collapse>
      <a-empty v-if="!cateList.length"/>
    </a-spin>
  </a-card>
  <!-- 添加分类 -->
  <a-modal :keyboard="false" :title="modalTitle" centered v-model:visible="visible" :confirm-loading="confirmLoading"
    @ok="handleOk" destroyOnClose>
    <a-form ref="groupForm" :model="group" :label-col="{span:5}" :wrapper-col="{span:18}">
      <a-form-item ref="warehouse_position_name" :label="group.warehouse_position_type == 1 ? '仓库名称':'库位名称'" name="warehouse_position_name" :rules="[{ required: true, message: '请输入'+(group.warehouse_position_type == 1 ? '仓库':'库位')+'名称'},{ max: 30, message: '仓库名称限30个字'}]">
        <a-input v-model:value="group.warehouse_position_name" :maxlength='30' :placeholder="'请输入'+(group.warehouse_position_type == 1 ? '仓库':'库位')+'名称'" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
  import { iscode } from "@/utils/app";
  import { onMounted, reactive, toRefs, ref, watch } from "vue";
  import { Modal,message } from "ant-design-vue";
  import {
    getWarehouseList,
    editWarehouse,
    addWarehouse,
    delWarehouse
  } from "@/api/antiFleeing.js";
  export default {
    setup(props) {
      const state = reactive({
        cateList: [],
        visible: false, //是否显示弹窗
        confirmLoading: false, //提交loading
        activeKey: [], //列表展开key数组
        modalTitle:'新增仓库', //弹窗title
        type:'add', //弹窗title类型
        loading:false
      });
      const initData = async () => {
        state.loading = true
        let result = await getWarehouseList().then((res) => res.data).catch(error => error);
        if (iscode(result)) {
          state.cateList = result.data;
        } else {
          message.error(result.msg);
        }
        state.loading = false
      };
      // 定义仓库表单绑定数据
      const group = ref();
      // 定义仓库表单ref
      const groupForm = ref();
      // 提交
      const handleOk = () => {
        groupForm.value.validate().then(async () => {
          state.confirmLoading = true;
          var result;
          if (state.type == 'add') {
            result = await addWarehouse({...group.value}).then(res => res.data).catch(error => error);
          } else {
            // 新增二级分类
            result = await editWarehouse({...group.value}).then(res => res.data).catch(error => error);
          } 
          if (iscode(result, true)) {
            state.visible = false;
            initData();
          }
          state.confirmLoading = false;
        }).catch((error) => { });
      };
      // 弹出表单
      const visibleToggle = (text,type,item) => {
        if(text == 'add'){
          group.value = { warehouse_position_name: "", warehouse_position_type: type, pid: type == 1 ? '' : item.id};
          state.modalTitle = type == 1 ? '新增仓库':'新增库位'
          state.type = text
        }else{
          group.value = { warehouse_position_name: item.name, wp_id: item.id };
          state.modalTitle = type == 1 ? '编辑仓库':'编辑库位'
          state.type = text
        }
        state.visible = true;
      };
      // 删除
      const del = (e) => {
        Modal.confirm({
          centered: true,
          content: e.pid ? "确定删除库位？":"确定删除仓库？",
          onOk: async () => {
            let res = await delWarehouse(e.id).then((res) => res.data);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
      };
      const changActiveKey = () => {
        if (state.activeKey.length) {
          state.activeKey = []
        } else {
          state.activeKey = []
          state.cateList.forEach((v, key) => {
            state.activeKey.push(String(key))
          })
        }
      }
      const changActive = (key) => {
        state.activeKey = []
        key.forEach(element => {
          state.activeKey.push(String(element))
        });
      };
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state),
        handleOk,
        group,
        groupForm,
        del,
        visibleToggle,
        changActive,
        changActiveKey
      };
    },
  };
</script>